export var SolutionGridLayout;
(function (SolutionGridLayout) {
    SolutionGridLayout["MARKETPLACE"] = "marketplace";
    SolutionGridLayout["INTEGRATIONS"] = "integrations";
})(SolutionGridLayout || (SolutionGridLayout = {}));
export var AppMarketWidget;
(function (AppMarketWidget) {
    AppMarketWidget["FINANCE_INTEGRATIONS"] = "finance-integrations";
    AppMarketWidget["MARKETING_INTEGRATIONS"] = "marketing-integrations";
    AppMarketWidget["APPS_RECOMMENDATIONS_WIDGETS"] = "app-recommendations-widget";
    AppMarketWidget["FULLFILLMENT_SERVICES"] = "stores-fulfillment-services";
    AppMarketWidget["MARKETING_HOME"] = "marketing-home";
})(AppMarketWidget || (AppMarketWidget = {}));
//# sourceMappingURL=types.js.map